@if (!loading) {
  <div>
    @if (!editMode) {
      <metadata-card-view fxLayout="column" fxFlex="100" fxLayoutAlign="space-around" [cardMetadata]="cardMetadata" [model]="model" [dense]="dense" [datacontroller]="datacontroller" (toggleEdit)="toggleEditMode()">
    </metadata-card-view>
  }
  @if (editMode) {
    <metadata-card-edit fxLayout="column" fxFlex="100" fxLayoutAlign="space-around" [cardMetadata]="cardMetadata" [model]="model" [dense]="dense" (toggleEdit)="toggleEditMode()" (overrideSave)="onSave()">
  </metadata-card-edit>
}
</div>
}
